export type ReminderInboxItem = {
  id: string;
  title: string;
  body: string;
  at: number;
  readAt?: number;
  dueAt?: number;
  kind?: "deadline" | "lesson";
};

const STORAGE_KEY = "reminder_inbox_v1";
const KEEP_MS = 7 * 24 * 60 * 60 * 1000;
const MAX_ITEMS = 200;

function clean(items: ReminderInboxItem[], now: number) {
  const fresh = items.filter((i) => Number.isFinite(i.at) && now - i.at <= KEEP_MS);
  fresh.sort((a, b) => b.at - a.at);
  return fresh.slice(0, MAX_ITEMS);
}

export function readReminderInbox(): ReminderInboxItem[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const items = JSON.parse(raw) as ReminderInboxItem[];
    return clean(Array.isArray(items) ? items : [], Date.now());
  } catch {
    return [];
  }
}

function writeReminderInbox(items: ReminderInboxItem[]) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new Event("reminder-inbox-updated"));
  } catch {
    // ignore
  }
}

export function addReminderInboxItem(item: ReminderInboxItem) {
  if (typeof window === "undefined") return;
  try {
    const now = Date.now();
    const existing = readReminderInbox();
    if (existing.some((e) => e.id === item.id)) return;
    const next = clean([item, ...existing], now);
    writeReminderInbox(next);
  } catch {
    // ignore
  }
}

export function markReminderInboxItemRead(id: string) {
  if (typeof window === "undefined") return;
  if (!id) return;
  try {
    const existing = readReminderInbox();
    let changed = false;
    const now = Date.now();
    const next = existing.map((e) => {
      if (e.id !== id) return e;
      if (e.readAt) return e;
      changed = true;
      return { ...e, readAt: now };
    });
    if (!changed) return;
    writeReminderInbox(next);
  } catch {
    // ignore
  }
}

export function clearReminderInbox() {
  if (typeof window === "undefined") return;
  try {
    writeReminderInbox([]);
  } catch {
    // ignore
  }
}
